import { Component, OnInit, Input } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';

@Component({
  selector: 'app-telefone-fixo-pj',
  templateUrl: './telefone-fixo-pj.component.html',
  styleUrls: ['./../cadastral-pj/cadastral-pj.component.css','./telefone-fixo-pj.component.css']
})
export class TelefoneFixoPjComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.telefone_fixo===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.telefone_fixo===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
